import React from "react";
import styled from "styled-components";
import { AppButton } from "site/ui";
import { usePremiumStore } from "store";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-family: "Manrope", sans-serif;
`;

const ModalContent = styled.div`
  display: flex;
  background: white;
  border-radius: 10px;
  width: 100%;
  max-width: 740px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const LeftSection = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
`;

const RightSection = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  max-height: 90vh;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;

  &:hover {
    color: #333;
  }
`;

const LeftImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("/assets/img.png");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 15px 0;
`;

const SubTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #5575f7;
  margin: 30px 0 20px 0;
`;

const BenefitList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 14px;
`;

const CheckIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #5575f7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #5575f7;
`;

const ButtonContainer = styled.div`
  margin-top: auto;
  padding-top: 20px;
`;

const PremiumSubscriptionModal: React.FC = () => {
  const { isPremiumModalOpen, closePremiumModal, subscribe, isLoading } =
    usePremiumStore();

  if (!isPremiumModalOpen) return null;

  const benefits = [
    "Unlimited access to past questions",
    "Timed & untimed quiz modes",
    "Progress tracking & performance insights",
    "Exclusive access to new content",
    "Personalized study recommendations",
    "Ad-free experience",
    "Exclusive study resources & tips",
    "Costs $4.99",
  ];

  return (
    <ModalOverlay>
      <ModalContent>
        <LeftSection>
          <LeftImage />
        </LeftSection>

        <RightSection>
          <CloseButton onClick={closePremiumModal}>×</CloseButton>
          <Title>Premium subscriber</Title>

          <SubTitle>What do I gain?</SubTitle>

          <BenefitList>
            {benefits.map((benefit, index) => (
              <BenefitItem key={index}>
                <CheckIcon>
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 5L4 7L8 3"
                      stroke="#5575F7"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CheckIcon>
                {benefit}
              </BenefitItem>
            ))}
          </BenefitList>

          <ButtonContainer>
            <AppButton
              variant="primary"
              fullWidth
              onClick={subscribe}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Subscribe with $4.99 / month"}
            </AppButton>
          </ButtonContainer>
        </RightSection>
      </ModalContent>
    </ModalOverlay>
  );
};

export default PremiumSubscriptionModal;
